module.exports = __webpack_public_path__ + "img/icon-financial-services.c926e890.svg";